module.exports = __webpack_public_path__ + "img/112.69eeabd1.jpg";